import{a as t}from"./chunk.2AIXLGYE.js";import{a as i}from"./chunk.NFEB7TIJ.js";import{a as o}from"./chunk.65JZXZ5X.js";import{c as r}from"./chunk.NWIV65VP.js";import{property as a}from"lit/decorators.js";import{html as m}from"lit/static-html.js";import{classMap as n}from"lit/directives/class-map.js";import{css as l}from"lit";var s=l`
  ${t}

  :host {
    display: block;
    overflow: hidden;
    position: relative;
    --color: var(--he-neutral-fill-hover);
    --shimmer-color: var(--he-neutral-fill-rest);
  }

  .skeleton {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 1rem;
    background: var(--color);
  }

  .skeleton.skeleton--shimmer {
    background: linear-gradient(270deg, var(--shimmer-color), var(--color), var(--color), var(--shimmer-color));
    background-size: 400% 100%;
    background-size: 400% 100%;
    animation: shimmer 7s ease-in-out infinite;
  }

  .skeleton--rect {
    border-radius: var(--he-border-radius-small);
  }

  .skeleton--circle {
    border-radius: 100%;
    overflow: hidden;
  }

  object {
    position: absolute;
    width: 100%;
    height: auto;
    z-index: 2;
  }

  object img {
    width: 100%;
    height: auto;
  }

  ::slotted(svg) {
    z-index: 2;
  }

  ::slotted(.pattern) {
    width: 100%;
    height: 100%;
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    to {
      background-position: -200% 0;
    }
  }

  @media screen and (forced-colors: active) {
    .skeleton,
    .skeleton.skeleton--shimmer {
      background: ${i.GrayText};
    }
  }
`;var e=class extends o{constructor(){super(...arguments);this.shimmer=!1;this.shape="rect"}render(){return m`
      <div
        class=${n({skeleton:!0,"skeleton--circle":this.shape==="circle","skeleton--rect":this.shape==="rect","skeleton--shimmer":this.shimmer})}
        aria-busy="true"
        aria-live="polite"
      >
        <slot></slot>
      </div>
    `}};e.styles=s,e.baseName="skeleton",e.reactEvents={},r([a({type:Boolean,reflect:!0})],e.prototype,"shimmer",2),r([a()],e.prototype,"shape",2);var y=e;export{e as a,y as b};
